module.exports = __webpack_public_path__ + "static/media/road-glide-special-black-2.aacaa2ec.png";